export const appHead = {"meta":[{"name":"msapplication-TileColor","content":"white"},{"name":"theme-color","content":"#0f84fa"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=5, viewport-fit=cover, interactive-widget=resizes-content"},{"hid":"og:type","name":"og:type","content":"company"},{"hid":"og:locale","name":"og:locale","content":"fa_IR"},{"hid":"author","name":"author","content":""},{"hid":"theme-color","name":"theme-color","content":"#239ad6"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/favicon/favicon.svg"},{"rel":"icon","sizes":"any","href":"/favicon.ico"},{"rel":"apple-touch-icon","href":"/favicon/apple-touch-icon.png"},{"rel":"preconnect","href":"https://audience.yektanet.com"},{"rel":"preconnect","href":"https://ua.yektanet.com"}],"style":[],"script":[{"id":"_webengage_script_tag","type":"text/javascript","innerHTML":"var webengage;!function(e,t,n,i,o){function s(e,t){e[t[t.length-1]]=function(){g.__queue.push([t.join(\".\"),arguments])}}var r,a,g=e[n],l=\"init options track screen onReady\".split(\" \"),c=\"feedback survey notification\".split(\" \"),p=\"options render clear abort\".split(\" \"),u=\"Open Close Submit Complete View Click\".split(\" \"),f=\"identify login logout setAttribute\".split(\" \");if(!g||!g.__v){for(e[n]=g={__queue:[],is_spa:0,__v:\"6.0\",user:{}},r=0;r<l.length;r++)s(g,[l[r]]);for(r=0;r<c.length;r++){for(g[c[r]]={},a=0;a<p.length;a++)s(g[c[r]],[c[r],p[a]]);for(a=0;a<u.length;a++)s(g[c[r]],[c[r],\"on\"+u[a]])}for(r=0;r<f.length;r++)s(g.user,[\"user\",f[r]]);setTimeout(function(){if(window.location.search.includes('layout=mobile')){return;}var e=t.createElement(\"script\"),n=t.getElementById(\"_webengage_script_tag\");e.type=\"text/javascript\",e.async=!0,e.src=(\"https:\"==t.location.protocol?\"https://we.mrbilit.ir\":\"http://we.mrbilit.ir\")+\"?url=https://ssl.widgets.webengage.com/js/webengage-min-v-6.0.js\",n.parentNode.insertBefore(e,n)})}}(window,document,\"webengage\"); webengage.init(\"76aa858\"); webengage.options('isGzip', true); webengage.options('proxyUrl', 'https://we.mrbilit.ir');"}],"noscript":[],"htmlAttrs":{"dir":"rtl","lang":"fa"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000